import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"

type alertModalProps = {
  close: any
  open: boolean
  title: string
  optionalMessage?: string
  buttonText: string
  confirmActionHandler?: any
}

type confirmModalProps = {
  close: any
  open: boolean
  confirmActionHandler: any
  title: string
  optionalMessage?: string | React.ReactNode
  confirmButtonText: string
  cancelButtonText: string
  api?: {
    loading: boolean
  }
}
export const ConfirmModal = ({
  close,
  open,
  confirmActionHandler,
  title,
  optionalMessage,
  confirmButtonText,
  cancelButtonText,
  api,
}: confirmModalProps) => {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="confirm-modal"
      aria-describedby={title}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          borderRadius: "8px",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "#fff",
          boxShadow: 24,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "30px",
            paddingTop: "50px",
          }}
        >
          <IconButton
            sx={{
              position: "absolute",
              top: 2,
              right: 2,
            }}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center",
              mx: "20px",
            }}
          >
            {title}
          </Typography>
          {optionalMessage && (
            <Typography
              sx={{
                fontSize: "14px",
                color: "#707070",
                textAlign: "center",
                mx: "20px",
              }}
            >
              {optionalMessage}
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: "20px",
            py: "14px",
            borderTop: "1px solid grey",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#3366D6",
              px: "35px",
              borderColor: "#3366D6",
            }}
            onClick={close}
          >
            {cancelButtonText}
          </Button>
          <Button
            endIcon={
              api ? (
                api.loading ? (
                  <CircularProgress size="1rem" sx={{ color: "#fff" }} />
                ) : undefined
              ) : undefined
            }
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              px: "20px",
              minWidth: "120px",
              backgroundColor: "#3366D6",
            }}
            onClick={confirmActionHandler}
          >
            {confirmButtonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export const AlertModal = ({
  close,
  open,
  title,
  optionalMessage,
  buttonText,
  confirmActionHandler,
}: alertModalProps) => {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="alert-modal"
      aria-describedby={title}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          borderRadius: "8px",
          transform: "translate(-50%, -50%)",
          width: 450,
          bgcolor: "#fff",
          boxShadow: 24,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "30px",
            paddingTop: "50px",
          }}
        >
          <ErrorOutlineIcon color="error" sx={{ fontSize: "50px" }} />
          <IconButton
            sx={{
              position: "absolute",
              top: 2,
              right: 2,
            }}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              textAlign: "center",
              mx: "20px",
            }}
          >
            {title}
          </Typography>
          {optionalMessage && (
            <Typography
              sx={{
                fontSize: "14px",
                color: "#707070",
                textAlign: "center",
                mx: "20px",
              }}
            >
              {optionalMessage}
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: confirmActionHandler ? "space-between" : "center",
            px: "20px",
          }}
        >
          {confirmActionHandler && (
            <Button
              variant="outlined"
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                color: "#3366D6",
                px: "60px",
                display: "flex",
                mb: "30px",
                borderColor: "#3366D6",
              }}
              onClick={close}
            >
              Cancel
            </Button>
          )}
          <Button
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#fff",
              px: "35px",
              display: "flex",
              mb: "30px",
            }}
            onClick={confirmActionHandler ? confirmActionHandler : close}
          >
            {buttonText}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
